<template>
  <div :data-incentive="incentiveId" v-if="showFeaturePromotion">
    <dyn-slot v-if="promotionActive && $slots.promoLayout" :slotData="slotData"><slot name="promoLayout"></slot></dyn-slot>

    <dyn-slot v-else-if="promotionActive && !$slots.promoLayout" :slotData="slotData" class="promo-badge" :class="[variantClass, sizeClass, positionClass]">
      <slot name="txtPromotion"></slot>
    </dyn-slot>

    <dyn-slot v-else :slotData="slotData"><slot name="nonPromoLayout"></slot></dyn-slot>
  </div>
</template>

<script>

import promoContext from '@/mixins/promoContext'
import useFeature from '@/mixins/useFeature'

export default {
  name: 'PromoTextBadge',
  mixins: [
    promoContext,
    useFeature('showFeaturePromotion')
  ],
  computed: {
    slotData: function () {
      return {
        tariff: this.tariff,
        promoAmount: this.promoAmount,
        promoUnit: this.promoUnit,
        amount: this.amount,
        unit: this.unit,
        limitedAmount: this.limitedAmount,
        activeIncentive: this.activeIncentive
      }
    },
    amount: function () {
      return this.effectiveTariff?.volumes?.[0]?.amount
    },
    unit: function () {
      return this.effectiveTariff?.volumes?.[0]?.unit
    },
    promotionActive: function () {
      return this.firstIncentiveId !== null
    },
    promoAmount: function () {
      let promoAmountSum = this.effectiveTariff?.volumes?.[0]?.amount
      this.appliedIncentives?.forEach(incentive => {
        promoAmountSum += incentive.amount !== null && incentive.amount !== undefined ? incentive.amount : 0
      })
      if (this.activeCoupon) {
        promoAmountSum += this.couponVolumeAmount !== null && this.couponVolumeAmount !== undefined ? this.couponVolumeAmount : 0
      }
      return promoAmountSum
    },
    promoUnit: function () {
      if (this.appliedIncentives && this.appliedIncentives.length > 0) {
        return this.appliedIncentives[0].unit
      }
      if (this.activeCoupon) {
        return this.couponVolumeUnit !== null && this.couponVolumeUnit !== undefined ? this.couponVolumeUnit : null
      }
      return null
    },
    limitedAmount: function () {
      // extra volume when promo is active
      return this.promoAmount - this.amount
    },
    firstIncentiveId: function () {
      if (this.appliedIncentives && this.appliedIncentives.length > 0) {
        return this.appliedIncentives[0].id
      }
      return null
    },
    activeIncentive: function () {
      return this.appliedIncentives?.[0]
    },
    incentiveId: function () {
      return this.activeIncentive?.id
    },
    variantClass: function () {
      if (this.variant) {
        return `promo-badge-${this.variant}`
      }
      return ''
    },
    sizeClass: function () {
      if (this.size) {
        return `promo-badge-size-${this.size}`
      }
      return ''
    },
    positionClass: function () {
      if (this.position) {
        return `promo-badge-position-${this.position}`
      }
      return ''
    },
    outsideActive: function () {
      return this.showFeaturePromotion
    }
  },
  props: {
    rawTariff: {
      type: String
    },
    variant: {
      // Supported Values: "round" "rect"
      type: String
    },
    size: {
      type: String
    }
  }
}
</script>
